import React from 'react';
import { useHistory } from 'react-router-dom';
import Button from '@mui/material/Button';
import { makeStyles } from '@mui/styles';
import * as Yup from 'yup';
import { useFormik } from 'formik';

import { useSnackbar } from 'notistack';
import { FormControl } from '../../Components/ui/FormControl';
import classes from './ResetPassword.module.scss';
import { ReactComponent as Point } from '../../assets/images/point.svg';
import { useRestorePassword } from '../../hooks/entityHooks';
import { RestorePassword } from '../../types/restorePassword';

type FormikValues = {
  newPassword: string;
  repeatNewPassword: string;
};

type Props = {
  token: string;
};

export const RestorePasswordPage = ({ token }: Props) => {
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const { restorePassword } = useRestorePassword();
  const handlerRestorePassword = (data: RestorePassword) => {
    restorePassword(data);
    history.push('/login');
  };
  const useStyles = makeStyles({
    root: {
      background: '#FF7221',
      borderRadius: 0,
      color: 'white',
      width: 190,
      fontSize: 16,
      fontFamily: 'HelveticaNeueCyr',
      '&:hover, &:focus': {
        background: '#FF7221',
      },
      // boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
      height: 50,
      padding: '0 5px',
      marginLeft: 10,
    },
    cancel: {
      borderRadius: 0,
      color: '#FF7221',
      width: 190,
      fontSize: 16,
      border: ['1px', 'solid', '#FF7221'].join(' '),
      borderColor: '#FF7221',
      fontFamily: 'HelveticaNeueCyr',
      // '&:hover, &:focus': {
      //   background: '#EB564F',
      // },
      // boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
      height: 50,
      padding: '0 5px',
      margitRight: 10,
    },
  });
  const {
    handleSubmit,
    handleBlur,
    values,
    errors,
    touched,
    setFieldValue,
  } = useFormik<FormikValues>({
    initialValues: {
      newPassword: '',
      repeatNewPassword: '',
    },
    onSubmit: () => {
      const data = {
        token,
        password: values.newPassword,
      };
      if (values.newPassword === values.repeatNewPassword) {
        handlerRestorePassword(data);
      } else {
        enqueueSnackbar('Пароли не совпадают', {
          variant: 'error',
        });
      }
    },
    validationSchema: Yup.object().shape({
      newPassword: Yup.string().required('Обязательно для заполнения'),
      repeatNewPassword: Yup.string().required('Обязательно для заполнения'),
    }),
  });
  const style = useStyles();
  return (
    <>
      <div className={classes.container}>
        <div className={classes.container__box}>
          <div className={classes.container__box__title}>
            <span>Восстановление пароля</span>
          </div>

          <form onSubmit={handleSubmit}>
            <div>
              <div className={classes.title}>
                <p>Новый пароль</p>
                <Point className={classes.title__point} />
              </div>
              <FormControl
                placeholder="Введите новый пароль"
                type="password"
                name="newPassword"
                value={values.newPassword}
                onChange={(e) => setFieldValue('newPassword', e.target.value)}
                error={Boolean(errors?.newPassword && touched?.newPassword)}
                errorMessage={errors?.newPassword}
                onBlur={handleBlur}
              />
            </div>

            <div>
              <div className={classes.title}>
                <p>Повторите новый пароль</p>
                <Point className={classes.title__point} />
              </div>
              <FormControl
                placeholder="Повторите новый пароль"
                type="password"
                name="repeatNewPassword"
                value={values.repeatNewPassword}
                onChange={(e) =>
                  setFieldValue('repeatNewPassword', e.target.value)
                }
                error={Boolean(
                  errors?.repeatNewPassword && touched?.repeatNewPassword,
                )}
                errorMessage={errors?.repeatNewPassword}
                onBlur={handleBlur}
              />
            </div>

            <div className={classes.container__box__buttons}>
              <Button
                className={style.cancel}
                onClick={(e) => history.push('/login')}
              >
                Отмена
              </Button>
              <Button className={style.root} type="submit">
                Изменить пароль
              </Button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};
